import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Partenaire } from '../_models/partenaire';


@Injectable({
  providedIn: 'root'
})

export class PartenaireService {
  constructor(private http: HttpClient) {
  }

  getPartenaires() {
    return this.http.get<Partenaire[]>(`${environment.api}/api/partenaires/display`);
  }

}
